/**
 * Store to cleanup functions for various lifecycle teardown
 * @module
 */
var _ = require('optimizely-client-fn');
var actionTypes = require('../constants/action_types');
var enums = require('../constants/enums');

module.exports = {
  initialize: function() {
    this.__state = {} as any;
    _.each(enums.Lifecycle, _.bind(function(lifecycle) {
      this.__state[lifecycle] = [];
    }, this));

    this.on(actionTypes.ADD_CLEANUP_FN, this.__addCleanupFn);
    this.on(actionTypes.CLEAR_CLEANUP_FN, this.__clearCleanupFn);
  },

  /**
   * @param {string} lifecycle
   * @return {Function[]}
   */
  getCleanupFns: function(lifecycle:string): Function[] {
    if (__INVARIANT__ && !this.__state[lifecycle]) {
      throw new Error('Invalid lifecycle ' + lifecycle);
    }
    return _.cloneDeep(this.__state[lifecycle]);
  },

  /**
   * @param {Object?} payload
   * @param {string} payload.lifecycle
   * @param {Function} payload.cleanupFn
   */
  __addCleanupFn: function(payload:any) {
    if (__INVARIANT__ && !this.__state[payload.lifecycle]) {
      throw new Error('Invalid lifecycle ' + payload.lifecycle);
    }
    this.__state[payload.lifecycle].push(payload.cleanupFn);
    this.emitChange();
  },

  /**
   * @param {Object?} payload
   * @param {string} payload.lifecycle
   * @param {Function?} payload.cleanupFn
   */
  __clearCleanupFn: function(payload:any) {
    var cleanupFns = this.__state[payload.lifecycle];
    if (__INVARIANT__ && !cleanupFns) {
      throw new Error('Invalid lifecycle ' + payload.lifecycle);
    }

    if (payload.cleanupFn) {
      // if cleanupFn is specified only remove that one
      var ind = cleanupFns.indexOf(payload.cleanupFn);
      if (ind > -1) {
        cleanupFns.splice(ind, 1);
        this.emitChange();
      }
    } else {
      // remove all cleanup functions
      this.__state[payload.lifecycle] = [];
      this.emitChange();
    }
  },
};
